// This file is auto-generated by @hey-api/openapi-ts

import {
  type Client,
  formDataBodySerializer,
  type Options as Options2,
  type TDataShape,
} from "./client";
import { client } from "./client.gen";
import type {
  DeleteApiTokensByIdData,
  DeleteApiTokensByIdErrors,
  DeleteApiTokensByIdResponses,
  DeleteAuthMeData,
  DeleteAuthMeResponses,
  DeleteOrganizationInvitationsByIdData,
  DeleteOrganizationInvitationsByIdErrors,
  DeleteOrganizationInvitationsByIdResponses,
  DeleteOrganizationMembersByUserIdData,
  DeleteOrganizationMembersByUserIdErrors,
  DeleteOrganizationMembersByUserIdResponses,
  DeleteProjectsByProjectIdData,
  DeleteProjectsByProjectIdErrors,
  DeleteProjectsByProjectIdHeartbeatsByIdData,
  DeleteProjectsByProjectIdHeartbeatsByIdErrors,
  DeleteProjectsByProjectIdHeartbeatsByIdResponses,
  DeleteProjectsByProjectIdIncidentsByIdData,
  DeleteProjectsByProjectIdIncidentsByIdErrors,
  DeleteProjectsByProjectIdIncidentsByIdResponses,
  DeleteProjectsByProjectIdMonitorsByIdData,
  DeleteProjectsByProjectIdMonitorsByIdErrors,
  DeleteProjectsByProjectIdMonitorsByIdResponses,
  DeleteProjectsByProjectIdMonitorsByMonitorIdIncidentsByIdData,
  DeleteProjectsByProjectIdMonitorsByMonitorIdIncidentsByIdErrors,
  DeleteProjectsByProjectIdMonitorsByMonitorIdIncidentsByIdResponses,
  DeleteProjectsByProjectIdResponses,
  DeleteProjectsByProjectIdStatusPagesByIdData,
  DeleteProjectsByProjectIdStatusPagesByIdErrors,
  DeleteProjectsByProjectIdStatusPagesByIdMaintenancesByMaintenanceIdData,
  DeleteProjectsByProjectIdStatusPagesByIdMaintenancesByMaintenanceIdErrors,
  DeleteProjectsByProjectIdStatusPagesByIdMaintenancesByMaintenanceIdResponses,
  DeleteProjectsByProjectIdStatusPagesByIdResponses,
  DeleteProjectsByProjectIdStatusPagesByIdSubscribersBySubscriberIdData,
  DeleteProjectsByProjectIdStatusPagesByIdSubscribersBySubscriberIdErrors,
  DeleteProjectsByProjectIdStatusPagesByIdSubscribersBySubscriberIdResponses,
  DeleteProjectsByProjectIdStatusPagesByIdUpdatesByUpdateIdData,
  DeleteProjectsByProjectIdStatusPagesByIdUpdatesByUpdateIdErrors,
  DeleteProjectsByProjectIdStatusPagesByIdUpdatesByUpdateIdResponses,
  DeletePushTokensData,
  DeletePushTokensErrors,
  DeletePushTokensResponses,
  DeleteSlackIntegrationData,
  DeleteSlackIntegrationErrors,
  DeleteSlackIntegrationResponses,
  DeleteWebhooksByIdData,
  DeleteWebhooksByIdErrors,
  DeleteWebhooksByIdResponses,
  GetApiTokensData,
  GetApiTokensResponses,
  GetAuthInvitationByTokenData,
  GetAuthInvitationByTokenErrors,
  GetAuthInvitationByTokenResponses,
  GetAuthMeData,
  GetAuthMeErrors,
  GetAuthMeResponses,
  GetBillingPlansData,
  GetBillingPlansResponses,
  GetBillingSubscriptionData,
  GetBillingSubscriptionResponses,
  GetHeartbeatByTokenPingData,
  GetHeartbeatByTokenPingErrors,
  GetHeartbeatByTokenPingResponses,
  GetIncidentsData,
  GetIncidentsResponses,
  GetOauthSlackCallbackData,
  GetOauthSlackData,
  GetOauthSlackErrors,
  GetOauthSlackResponses,
  GetOrganizationInvitationsData,
  GetOrganizationInvitationsResponses,
  GetOrganizationMembersData,
  GetOrganizationMembersResponses,
  GetOrganizationsData,
  GetOrganizationsResponses,
  GetProjectsByProjectIdAnomaliesData,
  GetProjectsByProjectIdAnomaliesErrors,
  GetProjectsByProjectIdAnomaliesRegionalData,
  GetProjectsByProjectIdAnomaliesRegionalErrors,
  GetProjectsByProjectIdAnomaliesRegionalResponses,
  GetProjectsByProjectIdAnomaliesResponses,
  GetProjectsByProjectIdHeartbeatsByIdData,
  GetProjectsByProjectIdHeartbeatsByIdErrors,
  GetProjectsByProjectIdHeartbeatsByIdPingsData,
  GetProjectsByProjectIdHeartbeatsByIdPingsErrors,
  GetProjectsByProjectIdHeartbeatsByIdPingsResponses,
  GetProjectsByProjectIdHeartbeatsByIdResponses,
  GetProjectsByProjectIdHeartbeatsData,
  GetProjectsByProjectIdHeartbeatsErrors,
  GetProjectsByProjectIdHeartbeatsResponses,
  GetProjectsByProjectIdIncidentsByIdData,
  GetProjectsByProjectIdIncidentsByIdErrors,
  GetProjectsByProjectIdIncidentsByIdResponses,
  GetProjectsByProjectIdIncidentsByIncidentIdCommentsData,
  GetProjectsByProjectIdIncidentsByIncidentIdCommentsErrors,
  GetProjectsByProjectIdIncidentsByIncidentIdCommentsResponses,
  GetProjectsByProjectIdIncidentsData,
  GetProjectsByProjectIdIncidentsErrors,
  GetProjectsByProjectIdIncidentsResponses,
  GetProjectsByProjectIdMonitorsByIdAvailabilityData,
  GetProjectsByProjectIdMonitorsByIdAvailabilityErrors,
  GetProjectsByProjectIdMonitorsByIdAvailabilityResponses,
  GetProjectsByProjectIdMonitorsByIdData,
  GetProjectsByProjectIdMonitorsByIdErrors,
  GetProjectsByProjectIdMonitorsByIdResponses,
  GetProjectsByProjectIdMonitorsByIdResponseTimesData,
  GetProjectsByProjectIdMonitorsByIdResponseTimesErrors,
  GetProjectsByProjectIdMonitorsByIdResponseTimesResponses,
  GetProjectsByProjectIdMonitorsByIdSummaryData,
  GetProjectsByProjectIdMonitorsByIdSummaryErrors,
  GetProjectsByProjectIdMonitorsByIdSummaryResponses,
  GetProjectsByProjectIdMonitorsByMonitorIdAnomaliesData,
  GetProjectsByProjectIdMonitorsByMonitorIdAnomaliesErrors,
  GetProjectsByProjectIdMonitorsByMonitorIdAnomaliesPredictionsData,
  GetProjectsByProjectIdMonitorsByMonitorIdAnomaliesPredictionsErrors,
  GetProjectsByProjectIdMonitorsByMonitorIdAnomaliesPredictionsResponses,
  GetProjectsByProjectIdMonitorsByMonitorIdAnomaliesResponses,
  GetProjectsByProjectIdMonitorsByMonitorIdAnomaliesSummaryData,
  GetProjectsByProjectIdMonitorsByMonitorIdAnomaliesSummaryErrors,
  GetProjectsByProjectIdMonitorsByMonitorIdAnomaliesSummaryResponses,
  GetProjectsByProjectIdMonitorsByMonitorIdAnomaliesTrendData,
  GetProjectsByProjectIdMonitorsByMonitorIdAnomaliesTrendErrors,
  GetProjectsByProjectIdMonitorsByMonitorIdAnomaliesTrendResponses,
  GetProjectsByProjectIdMonitorsByMonitorIdIncidentsByIdData,
  GetProjectsByProjectIdMonitorsByMonitorIdIncidentsByIdErrors,
  GetProjectsByProjectIdMonitorsByMonitorIdIncidentsByIdResponses,
  GetProjectsByProjectIdMonitorsByMonitorIdIncidentsByIncidentIdCommentsData,
  GetProjectsByProjectIdMonitorsByMonitorIdIncidentsByIncidentIdCommentsErrors,
  GetProjectsByProjectIdMonitorsByMonitorIdIncidentsByIncidentIdCommentsResponses,
  GetProjectsByProjectIdMonitorsByMonitorIdIncidentsData,
  GetProjectsByProjectIdMonitorsByMonitorIdIncidentsErrors,
  GetProjectsByProjectIdMonitorsByMonitorIdIncidentsResponses,
  GetProjectsByProjectIdMonitorsData,
  GetProjectsByProjectIdMonitorsErrors,
  GetProjectsByProjectIdMonitorsResponses,
  GetProjectsByProjectIdStatusPagesByIdData,
  GetProjectsByProjectIdStatusPagesByIdErrors,
  GetProjectsByProjectIdStatusPagesByIdMaintenancesData,
  GetProjectsByProjectIdStatusPagesByIdMaintenancesErrors,
  GetProjectsByProjectIdStatusPagesByIdMaintenancesResponses,
  GetProjectsByProjectIdStatusPagesByIdResponses,
  GetProjectsByProjectIdStatusPagesByIdSectionsData,
  GetProjectsByProjectIdStatusPagesByIdSectionsErrors,
  GetProjectsByProjectIdStatusPagesByIdSectionsResponses,
  GetProjectsByProjectIdStatusPagesByIdSubscribersData,
  GetProjectsByProjectIdStatusPagesByIdSubscribersErrors,
  GetProjectsByProjectIdStatusPagesByIdSubscribersResponses,
  GetProjectsByProjectIdStatusPagesByIdUpdatesData,
  GetProjectsByProjectIdStatusPagesByIdUpdatesErrors,
  GetProjectsByProjectIdStatusPagesByIdUpdatesResponses,
  GetProjectsByProjectIdStatusPagesData,
  GetProjectsByProjectIdStatusPagesErrors,
  GetProjectsByProjectIdStatusPagesResponses,
  GetProjectsData,
  GetProjectsResponses,
  GetSlackChannelsData,
  GetSlackChannelsErrors,
  GetSlackChannelsResponses,
  GetSlackIntegrationData,
  GetSlackIntegrationResponses,
  GetWebhooksByIdData,
  GetWebhooksByIdDeliveriesData,
  GetWebhooksByIdDeliveriesErrors,
  GetWebhooksByIdDeliveriesResponses,
  GetWebhooksByIdErrors,
  GetWebhooksByIdResponses,
  GetWebhooksData,
  GetWebhooksResponses,
  GetZonesData,
  GetZonesResponses,
  PatchAuthMeData,
  PatchAuthMeResponses,
  PatchOrganizationsByOrganizationIdData,
  PatchOrganizationsByOrganizationIdErrors,
  PatchOrganizationsByOrganizationIdResponses,
  PatchSlackIntegrationData,
  PatchSlackIntegrationErrors,
  PatchSlackIntegrationResponses,
  PatchUsersMeDefaultOrganizationData,
  PatchUsersMeDefaultOrganizationErrors,
  PatchUsersMeDefaultOrganizationResponses,
  PostApiTokensData,
  PostApiTokensResponses,
  PostAuthAcceptInviteData,
  PostAuthAcceptInviteErrors,
  PostAuthAcceptInviteResponses,
  PostAuthGoogleData,
  PostAuthGoogleErrors,
  PostAuthGoogleResponses,
  PostAuthLoginData,
  PostAuthLoginErrors,
  PostAuthLoginResponses,
  PostAuthRefreshTokenData,
  PostAuthRefreshTokenErrors,
  PostAuthRefreshTokenResponses,
  PostAuthRegisterData,
  PostAuthRegisterErrors,
  PostAuthRegisterResponses,
  PostAuthResetPasswordData,
  PostAuthResetPasswordErrors,
  PostAuthResetPasswordResponses,
  PostAuthRestorePasswordData,
  PostAuthRestorePasswordErrors,
  PostAuthRestorePasswordResponses,
  PostAuthVerifyEmailData,
  PostAuthVerifyEmailErrors,
  PostAuthVerifyEmailResponses,
  PostBillingCheckoutData,
  PostBillingCheckoutResponses,
  PostBillingPortalData,
  PostBillingPortalResponses,
  PostBillingWebhooksData,
  PostBillingWebhooksResponses,
  PostHeartbeatByTokenPingData,
  PostHeartbeatByTokenPingErrors,
  PostHeartbeatByTokenPingResponses,
  PostOrganizationInvitationsData,
  PostOrganizationInvitationsErrors,
  PostOrganizationInvitationsResponses,
  PostOrganizationsData,
  PostOrganizationsJoinData,
  PostOrganizationsJoinErrors,
  PostOrganizationsJoinResponses,
  PostOrganizationsResponses,
  PostProjectsByProjectIdHeartbeatsData,
  PostProjectsByProjectIdHeartbeatsErrors,
  PostProjectsByProjectIdHeartbeatsResponses,
  PostProjectsByProjectIdIncidentsByIncidentIdCommentsData,
  PostProjectsByProjectIdIncidentsByIncidentIdCommentsErrors,
  PostProjectsByProjectIdIncidentsByIncidentIdCommentsResponses,
  PostProjectsByProjectIdIncidentsData,
  PostProjectsByProjectIdIncidentsErrors,
  PostProjectsByProjectIdIncidentsResponses,
  PostProjectsByProjectIdMonitorsByIdTestAlertData,
  PostProjectsByProjectIdMonitorsByIdTestAlertErrors,
  PostProjectsByProjectIdMonitorsByIdTestAlertResponses,
  PostProjectsByProjectIdMonitorsByMonitorIdIncidentsByIncidentIdCommentsData,
  PostProjectsByProjectIdMonitorsByMonitorIdIncidentsByIncidentIdCommentsErrors,
  PostProjectsByProjectIdMonitorsByMonitorIdIncidentsByIncidentIdCommentsResponses,
  PostProjectsByProjectIdMonitorsByMonitorIdIncidentsData,
  PostProjectsByProjectIdMonitorsByMonitorIdIncidentsErrors,
  PostProjectsByProjectIdMonitorsByMonitorIdIncidentsResponses,
  PostProjectsByProjectIdMonitorsData,
  PostProjectsByProjectIdMonitorsErrors,
  PostProjectsByProjectIdMonitorsResponses,
  PostProjectsByProjectIdStatusPagesByIdMaintenancesData,
  PostProjectsByProjectIdStatusPagesByIdMaintenancesErrors,
  PostProjectsByProjectIdStatusPagesByIdMaintenancesResponses,
  PostProjectsByProjectIdStatusPagesByIdUpdatesData,
  PostProjectsByProjectIdStatusPagesByIdUpdatesErrors,
  PostProjectsByProjectIdStatusPagesByIdUpdatesResponses,
  PostProjectsByProjectIdStatusPagesData,
  PostProjectsByProjectIdStatusPagesDnsVerifyData,
  PostProjectsByProjectIdStatusPagesDnsVerifyErrors,
  PostProjectsByProjectIdStatusPagesDnsVerifyResponses,
  PostProjectsByProjectIdStatusPagesErrors,
  PostProjectsByProjectIdStatusPagesResponses,
  PostProjectsData,
  PostProjectsResponses,
  PostPushTokensData,
  PostPushTokensErrors,
  PostPushTokensResponses,
  PostSlackActionsData,
  PostSlackActionsResponses,
  PostSlackIntegrationTestData,
  PostSlackIntegrationTestErrors,
  PostSlackIntegrationTestResponses,
  PostUploadsData,
  PostUploadsErrors,
  PostUploadsResponses,
  PostWebhooksByIdTestData,
  PostWebhooksByIdTestErrors,
  PostWebhooksByIdTestResponses,
  PostWebhooksData,
  PostWebhooksResponses,
  PutOnboardingCompleteData,
  PutOnboardingCompleteErrors,
  PutOnboardingCompleteResponses,
  PutOrganizationMembersByUserIdRoleData,
  PutOrganizationMembersByUserIdRoleErrors,
  PutOrganizationMembersByUserIdRoleResponses,
  PutProjectsByProjectIdData,
  PutProjectsByProjectIdErrors,
  PutProjectsByProjectIdHeartbeatsByIdData,
  PutProjectsByProjectIdHeartbeatsByIdErrors,
  PutProjectsByProjectIdHeartbeatsByIdResponses,
  PutProjectsByProjectIdIncidentsByIdData,
  PutProjectsByProjectIdIncidentsByIdErrors,
  PutProjectsByProjectIdIncidentsByIdResponses,
  PutProjectsByProjectIdMonitorsByIdData,
  PutProjectsByProjectIdMonitorsByIdErrors,
  PutProjectsByProjectIdMonitorsByIdResponses,
  PutProjectsByProjectIdMonitorsByMonitorIdIncidentsByIdData,
  PutProjectsByProjectIdMonitorsByMonitorIdIncidentsByIdErrors,
  PutProjectsByProjectIdMonitorsByMonitorIdIncidentsByIdResponses,
  PutProjectsByProjectIdResponses,
  PutProjectsByProjectIdStatusPagesByIdData,
  PutProjectsByProjectIdStatusPagesByIdErrors,
  PutProjectsByProjectIdStatusPagesByIdMaintenancesByMaintenanceIdData,
  PutProjectsByProjectIdStatusPagesByIdMaintenancesByMaintenanceIdErrors,
  PutProjectsByProjectIdStatusPagesByIdMaintenancesByMaintenanceIdResponses,
  PutProjectsByProjectIdStatusPagesByIdMonitorsData,
  PutProjectsByProjectIdStatusPagesByIdMonitorsErrors,
  PutProjectsByProjectIdStatusPagesByIdMonitorsResponses,
  PutProjectsByProjectIdStatusPagesByIdResponses,
  PutProjectsByProjectIdStatusPagesByIdSectionsData,
  PutProjectsByProjectIdStatusPagesByIdSectionsErrors,
  PutProjectsByProjectIdStatusPagesByIdSectionsResponses,
  PutProjectsByProjectIdStatusPagesByIdUpdatesByUpdateIdData,
  PutProjectsByProjectIdStatusPagesByIdUpdatesByUpdateIdErrors,
  PutProjectsByProjectIdStatusPagesByIdUpdatesByUpdateIdResponses,
  PutWebhooksByIdData,
  PutWebhooksByIdErrors,
  PutWebhooksByIdResponses,
} from "./types.gen";

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
> = Options2<TData, ThrowOnError> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>;
};

/**
 * Receive a heartbeat ping. This is a public endpoint — no authentication required. Updates lastPingedAt and auto-resolves any open incident.
 */
export const getHeartbeatByTokenPing = <ThrowOnError extends boolean = false>(
  options: Options<GetHeartbeatByTokenPingData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetHeartbeatByTokenPingResponses,
    GetHeartbeatByTokenPingErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "X-Api-Key", type: "apiKey" },
    ],
    url: "/heartbeat/{token}/ping",
    ...options,
  });

/**
 * Receive a heartbeat ping via POST. Same behavior as GET ping endpoint.
 */
export const postHeartbeatByTokenPing = <ThrowOnError extends boolean = false>(
  options: Options<PostHeartbeatByTokenPingData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostHeartbeatByTokenPingResponses,
    PostHeartbeatByTokenPingErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "X-Api-Key", type: "apiKey" },
    ],
    url: "/heartbeat/{token}/ping",
    ...options,
  });

/**
 * Stripe webhook endpoint. Verified via Stripe signature, no auth required.
 */
export const postBillingWebhooks = <ThrowOnError extends boolean = false>(
  options?: Options<PostBillingWebhooksData, ThrowOnError>,
) =>
  (options?.client ?? client).post<
    PostBillingWebhooksResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "X-Api-Key", type: "apiKey" },
    ],
    url: "/billing/webhooks",
    ...options,
  });

/**
 * OAuth 2.0 callback from Slack. Exchanges the authorization code for a bot token and stores the integration. No authentication required.
 */
export const getOauthSlackCallback = <ThrowOnError extends boolean = false>(
  options?: Options<GetOauthSlackCallbackData, ThrowOnError>,
) =>
  (options?.client ?? client).get<unknown, unknown, ThrowOnError>({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "X-Api-Key", type: "apiKey" },
    ],
    url: "/oauth/slack/callback",
    ...options,
  });

/**
 * Slack Interactive Components endpoint. Handles button clicks (acknowledge / resolve) from incident notification messages. No authentication required — verified via Slack signing secret.
 */
export const postSlackActions = <ThrowOnError extends boolean = false>(
  options?: Options<PostSlackActionsData, ThrowOnError>,
) =>
  (options?.client ?? client).post<
    PostSlackActionsResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "X-Api-Key", type: "apiKey" },
    ],
    url: "/slack/actions",
    ...options,
  });

/**
 * Login
 *
 * Authenticate and receive token pair
 */
export const postAuthLogin = <ThrowOnError extends boolean = false>(
  options?: Options<PostAuthLoginData, ThrowOnError>,
) =>
  (options?.client ?? client).post<
    PostAuthLoginResponses,
    PostAuthLoginErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "X-Api-Key", type: "apiKey" },
    ],
    url: "/auth/login",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });

/**
 * Register a new user
 *
 * Create account and send a verification email. User must verify their email and then log in separately.
 */
export const postAuthRegister = <ThrowOnError extends boolean = false>(
  options?: Options<PostAuthRegisterData, ThrowOnError>,
) =>
  (options?.client ?? client).post<
    PostAuthRegisterResponses,
    PostAuthRegisterErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "X-Api-Key", type: "apiKey" },
    ],
    url: "/auth/register",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });

/**
 * Refresh tokens
 *
 * Exchange a refresh token for a new token pair
 */
export const postAuthRefreshToken = <ThrowOnError extends boolean = false>(
  options?: Options<PostAuthRefreshTokenData, ThrowOnError>,
) =>
  (options?.client ?? client).post<
    PostAuthRefreshTokenResponses,
    PostAuthRefreshTokenErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "X-Api-Key", type: "apiKey" },
    ],
    url: "/auth/refresh-token",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });

/**
 * Restore password
 *
 * Request a password reset email
 */
export const postAuthRestorePassword = <ThrowOnError extends boolean = false>(
  options?: Options<PostAuthRestorePasswordData, ThrowOnError>,
) =>
  (options?.client ?? client).post<
    PostAuthRestorePasswordResponses,
    PostAuthRestorePasswordErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "X-Api-Key", type: "apiKey" },
    ],
    url: "/auth/restore-password",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });

/**
 * Reset password
 *
 * Reset password using a token received via email
 */
export const postAuthResetPassword = <ThrowOnError extends boolean = false>(
  options?: Options<PostAuthResetPasswordData, ThrowOnError>,
) =>
  (options?.client ?? client).post<
    PostAuthResetPasswordResponses,
    PostAuthResetPasswordErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "X-Api-Key", type: "apiKey" },
    ],
    url: "/auth/reset-password",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });

/**
 * Verify email address
 *
 * Confirm email ownership using the verification token
 */
export const postAuthVerifyEmail = <ThrowOnError extends boolean = false>(
  options?: Options<PostAuthVerifyEmailData, ThrowOnError>,
) =>
  (options?.client ?? client).post<
    PostAuthVerifyEmailResponses,
    PostAuthVerifyEmailErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "X-Api-Key", type: "apiKey" },
    ],
    url: "/auth/verify-email",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });

/**
 * Validate invitation token
 *
 * Validate an invitation token and return invitation details
 */
export const getAuthInvitationByToken = <ThrowOnError extends boolean = false>(
  options: Options<GetAuthInvitationByTokenData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAuthInvitationByTokenResponses,
    GetAuthInvitationByTokenErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "X-Api-Key", type: "apiKey" },
    ],
    url: "/auth/invitation/{token}",
    ...options,
  });

/**
 * Accept invitation and create account
 *
 * Accept an organization invitation by creating a new account. The user joins the inviter's organization with the assigned role.
 */
export const postAuthAcceptInvite = <ThrowOnError extends boolean = false>(
  options?: Options<PostAuthAcceptInviteData, ThrowOnError>,
) =>
  (options?.client ?? client).post<
    PostAuthAcceptInviteResponses,
    PostAuthAcceptInviteErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "X-Api-Key", type: "apiKey" },
    ],
    url: "/auth/accept-invite",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });

/**
 * Authenticate with Google
 *
 * Exchange a Google authorization code for app tokens. Creates a new account if no matching user exists, or links the Google identity to an existing account matched by email.
 */
export const postAuthGoogle = <ThrowOnError extends boolean = false>(
  options?: Options<PostAuthGoogleData, ThrowOnError>,
) =>
  (options?.client ?? client).post<
    PostAuthGoogleResponses,
    PostAuthGoogleErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "X-Api-Key", type: "apiKey" },
    ],
    url: "/auth/google",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });

/**
 * Delete current user account
 *
 * Permanently delete the authenticated user's account and all associated data. This action cannot be undone.
 */
export const deleteAuthMe = <ThrowOnError extends boolean = false>(
  options?: Options<DeleteAuthMeData, ThrowOnError>,
) =>
  (options?.client ?? client).delete<
    DeleteAuthMeResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/auth/me",
    ...options,
  });

/**
 * Get current user
 *
 * Return the authenticated user's profile information
 */
export const getAuthMe = <ThrowOnError extends boolean = false>(
  options?: Options<GetAuthMeData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    GetAuthMeResponses,
    GetAuthMeErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/auth/me",
    ...options,
  });

/**
 * Update current user profile
 *
 * Update the authenticated user's profile information such as name, phone numbers, and timezone.
 */
export const patchAuthMe = <ThrowOnError extends boolean = false>(
  options?: Options<PatchAuthMeData, ThrowOnError>,
) =>
  (options?.client ?? client).patch<
    PatchAuthMeResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/auth/me",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });

/**
 * Join an organization via invitation
 *
 * Accept an organization invitation as an existing authenticated user. Creates a membership in the inviting organization.
 */
export const postOrganizationsJoin = <ThrowOnError extends boolean = false>(
  options?: Options<PostOrganizationsJoinData, ThrowOnError>,
) =>
  (options?.client ?? client).post<
    PostOrganizationsJoinResponses,
    PostOrganizationsJoinErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/organizations/join",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });

/**
 * Complete onboarding
 *
 * Set the organization and project names for a new user, completing their onboarding.
 */
export const putOnboardingComplete = <ThrowOnError extends boolean = false>(
  options?: Options<PutOnboardingCompleteData, ThrowOnError>,
) =>
  (options?.client ?? client).put<
    PutOnboardingCompleteResponses,
    PutOnboardingCompleteErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/onboarding/complete",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });

/**
 * List all projects in the authenticated user's organization
 */
export const getProjects = <ThrowOnError extends boolean = false>(
  options?: Options<GetProjectsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetProjectsResponses, unknown, ThrowOnError>({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "X-Api-Key", type: "apiKey" },
    ],
    url: "/projects",
    ...options,
  });

/**
 * Create a new project in the authenticated user's organization
 */
export const postProjects = <ThrowOnError extends boolean = false>(
  options?: Options<PostProjectsData, ThrowOnError>,
) =>
  (options?.client ?? client).post<
    PostProjectsResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "X-Api-Key", type: "apiKey" },
    ],
    url: "/projects",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });

/**
 * Delete a project and all its monitors (cascade)
 */
export const deleteProjectsByProjectId = <ThrowOnError extends boolean = false>(
  options: Options<DeleteProjectsByProjectIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteProjectsByProjectIdResponses,
    DeleteProjectsByProjectIdErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "X-Api-Key", type: "apiKey" },
    ],
    url: "/projects/{projectId}",
    ...options,
  });

/**
 * Update a project name
 */
export const putProjectsByProjectId = <ThrowOnError extends boolean = false>(
  options: Options<PutProjectsByProjectIdData, ThrowOnError>,
) =>
  (options.client ?? client).put<
    PutProjectsByProjectIdResponses,
    PutProjectsByProjectIdErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "X-Api-Key", type: "apiKey" },
    ],
    url: "/projects/{projectId}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List monitors in a project with pagination
 */
export const getProjectsByProjectIdMonitors = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetProjectsByProjectIdMonitorsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetProjectsByProjectIdMonitorsResponses,
    GetProjectsByProjectIdMonitorsErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "X-Api-Key", type: "apiKey" },
    ],
    url: "/projects/{projectId}/monitors",
    ...options,
  });

/**
 * Create a new monitor in a project
 */
export const postProjectsByProjectIdMonitors = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostProjectsByProjectIdMonitorsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostProjectsByProjectIdMonitorsResponses,
    PostProjectsByProjectIdMonitorsErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "X-Api-Key", type: "apiKey" },
    ],
    url: "/projects/{projectId}/monitors",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete a monitor and all its data
 */
export const deleteProjectsByProjectIdMonitorsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteProjectsByProjectIdMonitorsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteProjectsByProjectIdMonitorsByIdResponses,
    DeleteProjectsByProjectIdMonitorsByIdErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "X-Api-Key", type: "apiKey" },
    ],
    url: "/projects/{projectId}/monitors/{id}",
    ...options,
  });

/**
 * Get a single monitor by ID
 */
export const getProjectsByProjectIdMonitorsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetProjectsByProjectIdMonitorsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetProjectsByProjectIdMonitorsByIdResponses,
    GetProjectsByProjectIdMonitorsByIdErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "X-Api-Key", type: "apiKey" },
    ],
    url: "/projects/{projectId}/monitors/{id}",
    ...options,
  });

/**
 * Update an existing monitor
 */
export const putProjectsByProjectIdMonitorsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PutProjectsByProjectIdMonitorsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).put<
    PutProjectsByProjectIdMonitorsByIdResponses,
    PutProjectsByProjectIdMonitorsByIdErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "X-Api-Key", type: "apiKey" },
    ],
    url: "/projects/{projectId}/monitors/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get monitor summary stats including uptime streak, last check time, and incident count
 */
export const getProjectsByProjectIdMonitorsByIdSummary = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetProjectsByProjectIdMonitorsByIdSummaryData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetProjectsByProjectIdMonitorsByIdSummaryResponses,
    GetProjectsByProjectIdMonitorsByIdSummaryErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "X-Api-Key", type: "apiKey" },
    ],
    url: "/projects/{projectId}/monitors/{id}/summary",
    ...options,
  });

/**
 * Get response time series data for chart visualization. Supports breakdown (timing phases) and quantiles (p50/p95/p99) modes with configurable resolution.
 */
export const getProjectsByProjectIdMonitorsByIdResponseTimes = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetProjectsByProjectIdMonitorsByIdResponseTimesData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetProjectsByProjectIdMonitorsByIdResponseTimesResponses,
    GetProjectsByProjectIdMonitorsByIdResponseTimesErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "X-Api-Key", type: "apiKey" },
    ],
    url: "/projects/{projectId}/monitors/{id}/response-times",
    ...options,
  });

/**
 * Get availability statistics for predefined time periods and optional custom date range
 */
export const getProjectsByProjectIdMonitorsByIdAvailability = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetProjectsByProjectIdMonitorsByIdAvailabilityData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetProjectsByProjectIdMonitorsByIdAvailabilityResponses,
    GetProjectsByProjectIdMonitorsByIdAvailabilityErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "X-Api-Key", type: "apiKey" },
    ],
    url: "/projects/{projectId}/monitors/{id}/availability",
    ...options,
  });

/**
 * Send a test alert through all notification channels configured for the monitor. Creates a synthetic incident payload and dispatches it without creating a real incident.
 */
export const postProjectsByProjectIdMonitorsByIdTestAlert = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostProjectsByProjectIdMonitorsByIdTestAlertData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    PostProjectsByProjectIdMonitorsByIdTestAlertResponses,
    PostProjectsByProjectIdMonitorsByIdTestAlertErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "X-Api-Key", type: "apiKey" },
    ],
    url: "/projects/{projectId}/monitors/{id}/test-alert",
    ...options,
  });

/**
 * List heartbeats in a project with pagination
 */
export const getProjectsByProjectIdHeartbeats = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetProjectsByProjectIdHeartbeatsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetProjectsByProjectIdHeartbeatsResponses,
    GetProjectsByProjectIdHeartbeatsErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "X-Api-Key", type: "apiKey" },
    ],
    url: "/projects/{projectId}/heartbeats",
    ...options,
  });

/**
 * Create a new heartbeat monitor in a project. A unique ping token is auto-generated.
 */
export const postProjectsByProjectIdHeartbeats = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostProjectsByProjectIdHeartbeatsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostProjectsByProjectIdHeartbeatsResponses,
    PostProjectsByProjectIdHeartbeatsErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "X-Api-Key", type: "apiKey" },
    ],
    url: "/projects/{projectId}/heartbeats",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete a heartbeat monitor
 */
export const deleteProjectsByProjectIdHeartbeatsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteProjectsByProjectIdHeartbeatsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteProjectsByProjectIdHeartbeatsByIdResponses,
    DeleteProjectsByProjectIdHeartbeatsByIdErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "X-Api-Key", type: "apiKey" },
    ],
    url: "/projects/{projectId}/heartbeats/{id}",
    ...options,
  });

/**
 * Get a single heartbeat by ID
 */
export const getProjectsByProjectIdHeartbeatsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetProjectsByProjectIdHeartbeatsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetProjectsByProjectIdHeartbeatsByIdResponses,
    GetProjectsByProjectIdHeartbeatsByIdErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "X-Api-Key", type: "apiKey" },
    ],
    url: "/projects/{projectId}/heartbeats/{id}",
    ...options,
  });

/**
 * Update an existing heartbeat monitor
 */
export const putProjectsByProjectIdHeartbeatsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PutProjectsByProjectIdHeartbeatsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).put<
    PutProjectsByProjectIdHeartbeatsByIdResponses,
    PutProjectsByProjectIdHeartbeatsByIdErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "X-Api-Key", type: "apiKey" },
    ],
    url: "/projects/{projectId}/heartbeats/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List recent pings for a heartbeat. Returns up to 500 records within the requested time window.
 */
export const getProjectsByProjectIdHeartbeatsByIdPings = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetProjectsByProjectIdHeartbeatsByIdPingsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetProjectsByProjectIdHeartbeatsByIdPingsResponses,
    GetProjectsByProjectIdHeartbeatsByIdPingsErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "X-Api-Key", type: "apiKey" },
    ],
    url: "/projects/{projectId}/heartbeats/{id}/pings",
    ...options,
  });

/**
 * List all incidents across all projects in the authenticated user's organization
 */
export const getIncidents = <ThrowOnError extends boolean = false>(
  options?: Options<GetIncidentsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetIncidentsResponses, unknown, ThrowOnError>(
    {
      security: [
        { scheme: "bearer", type: "http" },
        { name: "X-Api-Key", type: "apiKey" },
      ],
      url: "/incidents",
      ...options,
    },
  );

/**
 * List all incidents for a project with cursor-based pagination
 */
export const getProjectsByProjectIdIncidents = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetProjectsByProjectIdIncidentsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetProjectsByProjectIdIncidentsResponses,
    GetProjectsByProjectIdIncidentsErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "X-Api-Key", type: "apiKey" },
    ],
    url: "/projects/{projectId}/incidents",
    ...options,
  });

/**
 * Create a new incident for a project, optionally linked to a monitor
 */
export const postProjectsByProjectIdIncidents = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostProjectsByProjectIdIncidentsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostProjectsByProjectIdIncidentsResponses,
    PostProjectsByProjectIdIncidentsErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "X-Api-Key", type: "apiKey" },
    ],
    url: "/projects/{projectId}/incidents",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List incidents for a monitor, optionally filtered by time period
 */
export const getProjectsByProjectIdMonitorsByMonitorIdIncidents = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetProjectsByProjectIdMonitorsByMonitorIdIncidentsData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetProjectsByProjectIdMonitorsByMonitorIdIncidentsResponses,
    GetProjectsByProjectIdMonitorsByMonitorIdIncidentsErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "X-Api-Key", type: "apiKey" },
    ],
    url: "/projects/{projectId}/monitors/{monitorId}/incidents",
    ...options,
  });

/**
 * Manually create a new incident for a monitor
 */
export const postProjectsByProjectIdMonitorsByMonitorIdIncidents = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostProjectsByProjectIdMonitorsByMonitorIdIncidentsData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    PostProjectsByProjectIdMonitorsByMonitorIdIncidentsResponses,
    PostProjectsByProjectIdMonitorsByMonitorIdIncidentsErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "X-Api-Key", type: "apiKey" },
    ],
    url: "/projects/{projectId}/monitors/{monitorId}/incidents",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete an incident
 */
export const deleteProjectsByProjectIdMonitorsByMonitorIdIncidentsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteProjectsByProjectIdMonitorsByMonitorIdIncidentsByIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).delete<
    DeleteProjectsByProjectIdMonitorsByMonitorIdIncidentsByIdResponses,
    DeleteProjectsByProjectIdMonitorsByMonitorIdIncidentsByIdErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "X-Api-Key", type: "apiKey" },
    ],
    url: "/projects/{projectId}/monitors/{monitorId}/incidents/{id}",
    ...options,
  });

/**
 * Get a single incident by ID with monitor information
 */
export const getProjectsByProjectIdMonitorsByMonitorIdIncidentsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetProjectsByProjectIdMonitorsByMonitorIdIncidentsByIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetProjectsByProjectIdMonitorsByMonitorIdIncidentsByIdResponses,
    GetProjectsByProjectIdMonitorsByMonitorIdIncidentsByIdErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "X-Api-Key", type: "apiKey" },
    ],
    url: "/projects/{projectId}/monitors/{monitorId}/incidents/{id}",
    ...options,
  });

/**
 * Update an existing incident
 */
export const putProjectsByProjectIdMonitorsByMonitorIdIncidentsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PutProjectsByProjectIdMonitorsByMonitorIdIncidentsByIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).put<
    PutProjectsByProjectIdMonitorsByMonitorIdIncidentsByIdResponses,
    PutProjectsByProjectIdMonitorsByMonitorIdIncidentsByIdErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "X-Api-Key", type: "apiKey" },
    ],
    url: "/projects/{projectId}/monitors/{monitorId}/incidents/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete an incident by project (for incidents with or without monitors)
 */
export const deleteProjectsByProjectIdIncidentsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteProjectsByProjectIdIncidentsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteProjectsByProjectIdIncidentsByIdResponses,
    DeleteProjectsByProjectIdIncidentsByIdErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "X-Api-Key", type: "apiKey" },
    ],
    url: "/projects/{projectId}/incidents/{id}",
    ...options,
  });

/**
 * Get a single incident by ID with monitor information (project-level)
 */
export const getProjectsByProjectIdIncidentsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetProjectsByProjectIdIncidentsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetProjectsByProjectIdIncidentsByIdResponses,
    GetProjectsByProjectIdIncidentsByIdErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "X-Api-Key", type: "apiKey" },
    ],
    url: "/projects/{projectId}/incidents/{id}",
    ...options,
  });

/**
 * Update an existing incident by project (for incidents with or without monitors)
 */
export const putProjectsByProjectIdIncidentsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PutProjectsByProjectIdIncidentsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).put<
    PutProjectsByProjectIdIncidentsByIdResponses,
    PutProjectsByProjectIdIncidentsByIdErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "X-Api-Key", type: "apiKey" },
    ],
    url: "/projects/{projectId}/incidents/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List all comments for an incident, ordered by creation time ascending
 */
export const getProjectsByProjectIdMonitorsByMonitorIdIncidentsByIncidentIdComments =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetProjectsByProjectIdMonitorsByMonitorIdIncidentsByIncidentIdCommentsData,
      ThrowOnError
    >,
  ) =>
    (options.client ?? client).get<
      GetProjectsByProjectIdMonitorsByMonitorIdIncidentsByIncidentIdCommentsResponses,
      GetProjectsByProjectIdMonitorsByMonitorIdIncidentsByIncidentIdCommentsErrors,
      ThrowOnError
    >({
      security: [
        { scheme: "bearer", type: "http" },
        { name: "X-Api-Key", type: "apiKey" },
      ],
      url: "/projects/{projectId}/monitors/{monitorId}/incidents/{incidentId}/comments",
      ...options,
    });

/**
 * Add a comment or post-mortem note to an incident
 */
export const postProjectsByProjectIdMonitorsByMonitorIdIncidentsByIncidentIdComments =
  <ThrowOnError extends boolean = false>(
    options: Options<
      PostProjectsByProjectIdMonitorsByMonitorIdIncidentsByIncidentIdCommentsData,
      ThrowOnError
    >,
  ) =>
    (options.client ?? client).post<
      PostProjectsByProjectIdMonitorsByMonitorIdIncidentsByIncidentIdCommentsResponses,
      PostProjectsByProjectIdMonitorsByMonitorIdIncidentsByIncidentIdCommentsErrors,
      ThrowOnError
    >({
      security: [
        { scheme: "bearer", type: "http" },
        { name: "X-Api-Key", type: "apiKey" },
      ],
      url: "/projects/{projectId}/monitors/{monitorId}/incidents/{incidentId}/comments",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });

/**
 * List all comments for an incident, ordered by creation time ascending
 */
export const getProjectsByProjectIdIncidentsByIncidentIdComments = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetProjectsByProjectIdIncidentsByIncidentIdCommentsData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetProjectsByProjectIdIncidentsByIncidentIdCommentsResponses,
    GetProjectsByProjectIdIncidentsByIncidentIdCommentsErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "X-Api-Key", type: "apiKey" },
    ],
    url: "/projects/{projectId}/incidents/{incidentId}/comments",
    ...options,
  });

/**
 * Add a comment or post-mortem note to an incident
 */
export const postProjectsByProjectIdIncidentsByIncidentIdComments = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostProjectsByProjectIdIncidentsByIncidentIdCommentsData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    PostProjectsByProjectIdIncidentsByIncidentIdCommentsResponses,
    PostProjectsByProjectIdIncidentsByIncidentIdCommentsErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "X-Api-Key", type: "apiKey" },
    ],
    url: "/projects/{projectId}/incidents/{incidentId}/comments",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List all status pages in a project
 */
export const getProjectsByProjectIdStatusPages = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetProjectsByProjectIdStatusPagesData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetProjectsByProjectIdStatusPagesResponses,
    GetProjectsByProjectIdStatusPagesErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "X-Api-Key", type: "apiKey" },
    ],
    url: "/projects/{projectId}/status-pages",
    ...options,
  });

/**
 * Create a new status page in a project
 */
export const postProjectsByProjectIdStatusPages = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostProjectsByProjectIdStatusPagesData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostProjectsByProjectIdStatusPagesResponses,
    PostProjectsByProjectIdStatusPagesErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "X-Api-Key", type: "apiKey" },
    ],
    url: "/projects/{projectId}/status-pages",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete a status page
 */
export const deleteProjectsByProjectIdStatusPagesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteProjectsByProjectIdStatusPagesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteProjectsByProjectIdStatusPagesByIdResponses,
    DeleteProjectsByProjectIdStatusPagesByIdErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "X-Api-Key", type: "apiKey" },
    ],
    url: "/projects/{projectId}/status-pages/{id}",
    ...options,
  });

/**
 * Get a single status page with its linked monitors
 */
export const getProjectsByProjectIdStatusPagesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetProjectsByProjectIdStatusPagesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetProjectsByProjectIdStatusPagesByIdResponses,
    GetProjectsByProjectIdStatusPagesByIdErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "X-Api-Key", type: "apiKey" },
    ],
    url: "/projects/{projectId}/status-pages/{id}",
    ...options,
  });

/**
 * Update an existing status page
 */
export const putProjectsByProjectIdStatusPagesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PutProjectsByProjectIdStatusPagesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).put<
    PutProjectsByProjectIdStatusPagesByIdResponses,
    PutProjectsByProjectIdStatusPagesByIdErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "X-Api-Key", type: "apiKey" },
    ],
    url: "/projects/{projectId}/status-pages/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Verify that a custom domain has the correct CNAME record pointing to the status page infrastructure
 */
export const postProjectsByProjectIdStatusPagesDnsVerify = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostProjectsByProjectIdStatusPagesDnsVerifyData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    PostProjectsByProjectIdStatusPagesDnsVerifyResponses,
    PostProjectsByProjectIdStatusPagesDnsVerifyErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "X-Api-Key", type: "apiKey" },
    ],
    url: "/projects/{projectId}/status-pages/dns-verify",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Set the monitors displayed on a status page. Replaces the entire monitor list.
 */
export const putProjectsByProjectIdStatusPagesByIdMonitors = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PutProjectsByProjectIdStatusPagesByIdMonitorsData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).put<
    PutProjectsByProjectIdStatusPagesByIdMonitorsResponses,
    PutProjectsByProjectIdStatusPagesByIdMonitorsErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "X-Api-Key", type: "apiKey" },
    ],
    url: "/projects/{projectId}/status-pages/{id}/monitors",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List all maintenance windows for a status page
 */
export const getProjectsByProjectIdStatusPagesByIdMaintenances = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetProjectsByProjectIdStatusPagesByIdMaintenancesData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetProjectsByProjectIdStatusPagesByIdMaintenancesResponses,
    GetProjectsByProjectIdStatusPagesByIdMaintenancesErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "X-Api-Key", type: "apiKey" },
    ],
    url: "/projects/{projectId}/status-pages/{id}/maintenances",
    ...options,
  });

/**
 * Create a maintenance window for a status page
 */
export const postProjectsByProjectIdStatusPagesByIdMaintenances = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostProjectsByProjectIdStatusPagesByIdMaintenancesData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    PostProjectsByProjectIdStatusPagesByIdMaintenancesResponses,
    PostProjectsByProjectIdStatusPagesByIdMaintenancesErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "X-Api-Key", type: "apiKey" },
    ],
    url: "/projects/{projectId}/status-pages/{id}/maintenances",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete a maintenance window
 */
export const deleteProjectsByProjectIdStatusPagesByIdMaintenancesByMaintenanceId =
  <ThrowOnError extends boolean = false>(
    options: Options<
      DeleteProjectsByProjectIdStatusPagesByIdMaintenancesByMaintenanceIdData,
      ThrowOnError
    >,
  ) =>
    (options.client ?? client).delete<
      DeleteProjectsByProjectIdStatusPagesByIdMaintenancesByMaintenanceIdResponses,
      DeleteProjectsByProjectIdStatusPagesByIdMaintenancesByMaintenanceIdErrors,
      ThrowOnError
    >({
      security: [
        { scheme: "bearer", type: "http" },
        { name: "X-Api-Key", type: "apiKey" },
      ],
      url: "/projects/{projectId}/status-pages/{id}/maintenances/{maintenanceId}",
      ...options,
    });

/**
 * Update a maintenance window
 */
export const putProjectsByProjectIdStatusPagesByIdMaintenancesByMaintenanceId =
  <ThrowOnError extends boolean = false>(
    options: Options<
      PutProjectsByProjectIdStatusPagesByIdMaintenancesByMaintenanceIdData,
      ThrowOnError
    >,
  ) =>
    (options.client ?? client).put<
      PutProjectsByProjectIdStatusPagesByIdMaintenancesByMaintenanceIdResponses,
      PutProjectsByProjectIdStatusPagesByIdMaintenancesByMaintenanceIdErrors,
      ThrowOnError
    >({
      security: [
        { scheme: "bearer", type: "http" },
        { name: "X-Api-Key", type: "apiKey" },
      ],
      url: "/projects/{projectId}/status-pages/{id}/maintenances/{maintenanceId}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    });

/**
 * List all sections for a status page, each with their monitors. Includes a virtual 'uncategorized' section for monitors not assigned to any section.
 */
export const getProjectsByProjectIdStatusPagesByIdSections = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetProjectsByProjectIdStatusPagesByIdSectionsData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetProjectsByProjectIdStatusPagesByIdSectionsResponses,
    GetProjectsByProjectIdStatusPagesByIdSectionsErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "X-Api-Key", type: "apiKey" },
    ],
    url: "/projects/{projectId}/status-pages/{id}/sections",
    ...options,
  });

/**
 * Replace all sections and monitor assignments for a status page. Runs in a transaction.
 */
export const putProjectsByProjectIdStatusPagesByIdSections = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PutProjectsByProjectIdStatusPagesByIdSectionsData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).put<
    PutProjectsByProjectIdStatusPagesByIdSectionsResponses,
    PutProjectsByProjectIdStatusPagesByIdSectionsErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "X-Api-Key", type: "apiKey" },
    ],
    url: "/projects/{projectId}/status-pages/{id}/sections",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List all status updates for a status page, sorted newest first.
 */
export const getProjectsByProjectIdStatusPagesByIdUpdates = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetProjectsByProjectIdStatusPagesByIdUpdatesData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetProjectsByProjectIdStatusPagesByIdUpdatesResponses,
    GetProjectsByProjectIdStatusPagesByIdUpdatesErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "X-Api-Key", type: "apiKey" },
    ],
    url: "/projects/{projectId}/status-pages/{id}/updates",
    ...options,
  });

/**
 * Post a new status update to a status page.
 */
export const postProjectsByProjectIdStatusPagesByIdUpdates = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostProjectsByProjectIdStatusPagesByIdUpdatesData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).post<
    PostProjectsByProjectIdStatusPagesByIdUpdatesResponses,
    PostProjectsByProjectIdStatusPagesByIdUpdatesErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "X-Api-Key", type: "apiKey" },
    ],
    url: "/projects/{projectId}/status-pages/{id}/updates",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete a status page update.
 */
export const deleteProjectsByProjectIdStatusPagesByIdUpdatesByUpdateId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteProjectsByProjectIdStatusPagesByIdUpdatesByUpdateIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).delete<
    DeleteProjectsByProjectIdStatusPagesByIdUpdatesByUpdateIdResponses,
    DeleteProjectsByProjectIdStatusPagesByIdUpdatesByUpdateIdErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "X-Api-Key", type: "apiKey" },
    ],
    url: "/projects/{projectId}/status-pages/{id}/updates/{updateId}",
    ...options,
  });

/**
 * Update an existing status page update.
 */
export const putProjectsByProjectIdStatusPagesByIdUpdatesByUpdateId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PutProjectsByProjectIdStatusPagesByIdUpdatesByUpdateIdData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).put<
    PutProjectsByProjectIdStatusPagesByIdUpdatesByUpdateIdResponses,
    PutProjectsByProjectIdStatusPagesByIdUpdatesByUpdateIdErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "X-Api-Key", type: "apiKey" },
    ],
    url: "/projects/{projectId}/status-pages/{id}/updates/{updateId}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List subscribers for a status page with pagination. Token is not returned.
 */
export const getProjectsByProjectIdStatusPagesByIdSubscribers = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetProjectsByProjectIdStatusPagesByIdSubscribersData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetProjectsByProjectIdStatusPagesByIdSubscribersResponses,
    GetProjectsByProjectIdStatusPagesByIdSubscribersErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "X-Api-Key", type: "apiKey" },
    ],
    url: "/projects/{projectId}/status-pages/{id}/subscribers",
    ...options,
  });

/**
 * Remove a subscriber from a status page.
 */
export const deleteProjectsByProjectIdStatusPagesByIdSubscribersBySubscriberId =
  <ThrowOnError extends boolean = false>(
    options: Options<
      DeleteProjectsByProjectIdStatusPagesByIdSubscribersBySubscriberIdData,
      ThrowOnError
    >,
  ) =>
    (options.client ?? client).delete<
      DeleteProjectsByProjectIdStatusPagesByIdSubscribersBySubscriberIdResponses,
      DeleteProjectsByProjectIdStatusPagesByIdSubscribersBySubscriberIdErrors,
      ThrowOnError
    >({
      security: [
        { scheme: "bearer", type: "http" },
        { name: "X-Api-Key", type: "apiKey" },
      ],
      url: "/projects/{projectId}/status-pages/{id}/subscribers/{subscriberId}",
      ...options,
    });

/**
 * List organization members
 *
 * List all members of the authenticated user's organization
 */
export const getOrganizationMembers = <ThrowOnError extends boolean = false>(
  options?: Options<GetOrganizationMembersData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    GetOrganizationMembersResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/organization/members",
    ...options,
  });

/**
 * Change member role
 *
 * Change a member's role (admin only). Cannot demote the last admin.
 */
export const putOrganizationMembersByUserIdRole = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PutOrganizationMembersByUserIdRoleData, ThrowOnError>,
) =>
  (options.client ?? client).put<
    PutOrganizationMembersByUserIdRoleResponses,
    PutOrganizationMembersByUserIdRoleErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/organization/members/{userId}/role",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Remove member
 *
 * Remove a member from the organization (admin only). Cannot remove yourself.
 */
export const deleteOrganizationMembersByUserId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteOrganizationMembersByUserIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteOrganizationMembersByUserIdResponses,
    DeleteOrganizationMembersByUserIdErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/organization/members/{userId}",
    ...options,
  });

/**
 * List pending invitations
 *
 * List all pending invitations for the organization (admin only)
 */
export const getOrganizationInvitations = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetOrganizationInvitationsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    GetOrganizationInvitationsResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/organization/invitations",
    ...options,
  });

/**
 * Send invitation
 *
 * Invite a user to the organization by email (admin only)
 */
export const postOrganizationInvitations = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<PostOrganizationInvitationsData, ThrowOnError>,
) =>
  (options?.client ?? client).post<
    PostOrganizationInvitationsResponses,
    PostOrganizationInvitationsErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/organization/invitations",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });

/**
 * Cancel invitation
 *
 * Cancel a pending invitation (admin only)
 */
export const deleteOrganizationInvitationsById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteOrganizationInvitationsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteOrganizationInvitationsByIdResponses,
    DeleteOrganizationInvitationsByIdErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/organization/invitations/{id}",
    ...options,
  });

/**
 * List all organizations the authenticated user belongs to
 */
export const getOrganizations = <ThrowOnError extends boolean = false>(
  options?: Options<GetOrganizationsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    GetOrganizationsResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "X-Api-Key", type: "apiKey" },
    ],
    url: "/organizations",
    ...options,
  });

/**
 * Create a new organization. The authenticated user becomes its admin.
 */
export const postOrganizations = <ThrowOnError extends boolean = false>(
  options?: Options<PostOrganizationsData, ThrowOnError>,
) =>
  (options?.client ?? client).post<
    PostOrganizationsResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "X-Api-Key", type: "apiKey" },
    ],
    url: "/organizations",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });

/**
 * Update an organization. Only admins of the organization can update it.
 */
export const patchOrganizationsByOrganizationId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchOrganizationsByOrganizationIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    PatchOrganizationsByOrganizationIdResponses,
    PatchOrganizationsByOrganizationIdErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "X-Api-Key", type: "apiKey" },
    ],
    url: "/organizations/{organizationId}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Unregister a push token
 *
 * Remove an Expo push token for the authenticated user (e.g. on logout).
 */
export const deletePushTokens = <ThrowOnError extends boolean = false>(
  options?: Options<DeletePushTokensData, ThrowOnError>,
) =>
  (options?.client ?? client).delete<
    DeletePushTokensResponses,
    DeletePushTokensErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/push-tokens",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });

/**
 * Register a push token
 *
 * Register an Expo push token for the authenticated user. If the token already exists for this user it is a no-op.
 */
export const postPushTokens = <ThrowOnError extends boolean = false>(
  options?: Options<PostPushTokensData, ThrowOnError>,
) =>
  (options?.client ?? client).post<
    PostPushTokensResponses,
    PostPushTokensErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/push-tokens",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });

/**
 * List all webhooks for the authenticated user's organization
 */
export const getWebhooks = <ThrowOnError extends boolean = false>(
  options?: Options<GetWebhooksData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetWebhooksResponses, unknown, ThrowOnError>({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "X-Api-Key", type: "apiKey" },
    ],
    url: "/webhooks",
    ...options,
  });

/**
 * Create a new webhook for the organization
 */
export const postWebhooks = <ThrowOnError extends boolean = false>(
  options?: Options<PostWebhooksData, ThrowOnError>,
) =>
  (options?.client ?? client).post<
    PostWebhooksResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "X-Api-Key", type: "apiKey" },
    ],
    url: "/webhooks",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });

/**
 * Delete a webhook
 */
export const deleteWebhooksById = <ThrowOnError extends boolean = false>(
  options: Options<DeleteWebhooksByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteWebhooksByIdResponses,
    DeleteWebhooksByIdErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "X-Api-Key", type: "apiKey" },
    ],
    url: "/webhooks/{id}",
    ...options,
  });

/**
 * Get a single webhook by ID
 */
export const getWebhooksById = <ThrowOnError extends boolean = false>(
  options: Options<GetWebhooksByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetWebhooksByIdResponses,
    GetWebhooksByIdErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "X-Api-Key", type: "apiKey" },
    ],
    url: "/webhooks/{id}",
    ...options,
  });

/**
 * Update an existing webhook
 */
export const putWebhooksById = <ThrowOnError extends boolean = false>(
  options: Options<PutWebhooksByIdData, ThrowOnError>,
) =>
  (options.client ?? client).put<
    PutWebhooksByIdResponses,
    PutWebhooksByIdErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "X-Api-Key", type: "apiKey" },
    ],
    url: "/webhooks/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Send a test delivery to a webhook
 */
export const postWebhooksByIdTest = <ThrowOnError extends boolean = false>(
  options: Options<PostWebhooksByIdTestData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostWebhooksByIdTestResponses,
    PostWebhooksByIdTestErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "X-Api-Key", type: "apiKey" },
    ],
    url: "/webhooks/{id}/test",
    ...options,
  });

/**
 * List recent deliveries for a webhook
 */
export const getWebhooksByIdDeliveries = <ThrowOnError extends boolean = false>(
  options: Options<GetWebhooksByIdDeliveriesData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetWebhooksByIdDeliveriesResponses,
    GetWebhooksByIdDeliveriesErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "X-Api-Key", type: "apiKey" },
    ],
    url: "/webhooks/{id}/deliveries",
    ...options,
  });

/**
 * Get all available plans with their limits and pricing
 */
export const getBillingPlans = <ThrowOnError extends boolean = false>(
  options?: Options<GetBillingPlansData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    GetBillingPlansResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/billing/plans",
    ...options,
  });

/**
 * Get the current organization subscription, plan limits, and usage
 */
export const getBillingSubscription = <ThrowOnError extends boolean = false>(
  options?: Options<GetBillingSubscriptionData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    GetBillingSubscriptionResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/billing/subscription",
    ...options,
  });

/**
 * Create a Stripe Checkout session to subscribe to a paid plan. Requires admin role. Returns 403 if not admin, 400 if Stripe price not configured.
 */
export const postBillingCheckout = <ThrowOnError extends boolean = false>(
  options?: Options<PostBillingCheckoutData, ThrowOnError>,
) =>
  (options?.client ?? client).post<
    PostBillingCheckoutResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/billing/checkout",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });

/**
 * Create a Stripe Customer Portal session to manage billing. Requires admin role. Returns 403 if not admin.
 */
export const postBillingPortal = <ThrowOnError extends boolean = false>(
  options?: Options<PostBillingPortalData, ThrowOnError>,
) =>
  (options?.client ?? client).post<
    PostBillingPortalResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/billing/portal",
    ...options,
  });

/**
 * List anomaly events for a monitor
 *
 * Returns paginated anomaly events detected for a specific monitor. Requires Pro or Business plan.
 */
export const getProjectsByProjectIdMonitorsByMonitorIdAnomalies = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetProjectsByProjectIdMonitorsByMonitorIdAnomaliesData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetProjectsByProjectIdMonitorsByMonitorIdAnomaliesResponses,
    GetProjectsByProjectIdMonitorsByMonitorIdAnomaliesErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "X-Api-Key", type: "apiKey" },
    ],
    url: "/projects/{projectId}/monitors/{monitorId}/anomalies",
    ...options,
  });

/**
 * Get anomaly summary for a monitor
 *
 * Returns a quick summary of anomaly counts and the last anomaly timestamp for a monitor.
 */
export const getProjectsByProjectIdMonitorsByMonitorIdAnomaliesSummary = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetProjectsByProjectIdMonitorsByMonitorIdAnomaliesSummaryData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetProjectsByProjectIdMonitorsByMonitorIdAnomaliesSummaryResponses,
    GetProjectsByProjectIdMonitorsByMonitorIdAnomaliesSummaryErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "X-Api-Key", type: "apiKey" },
    ],
    url: "/projects/{projectId}/monitors/{monitorId}/anomalies/summary",
    ...options,
  });

/**
 * Get latency trend analysis for a monitor
 *
 * Returns hourly latency data for the last 12 hours with linear regression trend analysis. Detects gradual degradation patterns.
 */
export const getProjectsByProjectIdMonitorsByMonitorIdAnomaliesTrend = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetProjectsByProjectIdMonitorsByMonitorIdAnomaliesTrendData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetProjectsByProjectIdMonitorsByMonitorIdAnomaliesTrendResponses,
    GetProjectsByProjectIdMonitorsByMonitorIdAnomaliesTrendErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "X-Api-Key", type: "apiKey" },
    ],
    url: "/projects/{projectId}/monitors/{monitorId}/anomalies/trend",
    ...options,
  });

/**
 * Get active predictions for a monitor
 *
 * Returns the latest predictive_breach and changepoint events for a monitor from the last 24 hours, giving forward-looking insights into degradation trends.
 */
export const getProjectsByProjectIdMonitorsByMonitorIdAnomaliesPredictions = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetProjectsByProjectIdMonitorsByMonitorIdAnomaliesPredictionsData,
    ThrowOnError
  >,
) =>
  (options.client ?? client).get<
    GetProjectsByProjectIdMonitorsByMonitorIdAnomaliesPredictionsResponses,
    GetProjectsByProjectIdMonitorsByMonitorIdAnomaliesPredictionsErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "X-Api-Key", type: "apiKey" },
    ],
    url: "/projects/{projectId}/monitors/{monitorId}/anomalies/predictions",
    ...options,
  });

/**
 * List recent anomalies across all monitors in a project
 *
 * Returns recent anomaly events for all monitors in a project. Defaults to last 24 hours.
 */
export const getProjectsByProjectIdAnomalies = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetProjectsByProjectIdAnomaliesData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetProjectsByProjectIdAnomaliesResponses,
    GetProjectsByProjectIdAnomaliesErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "X-Api-Key", type: "apiKey" },
    ],
    url: "/projects/{projectId}/anomalies",
    ...options,
  });

/**
 * List regional degradation events
 *
 * Returns anomaly events of type 'regional_degradation' for a project, which indicate infrastructure-level issues affecting multiple monitors in the same region.
 */
export const getProjectsByProjectIdAnomaliesRegional = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetProjectsByProjectIdAnomaliesRegionalData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetProjectsByProjectIdAnomaliesRegionalResponses,
    GetProjectsByProjectIdAnomaliesRegionalErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "X-Api-Key", type: "apiKey" },
    ],
    url: "/projects/{projectId}/anomalies/regional",
    ...options,
  });

/**
 * Initiate Slack OAuth flow. Returns the Slack authorization URL. The client should redirect the browser to this URL.
 */
export const getOauthSlack = <ThrowOnError extends boolean = false>(
  options?: Options<GetOauthSlackData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    GetOauthSlackResponses,
    GetOauthSlackErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "X-Api-Key", type: "apiKey" },
    ],
    url: "/oauth/slack",
    ...options,
  });

/**
 * Disconnect the Slack integration for the current organization.
 */
export const deleteSlackIntegration = <ThrowOnError extends boolean = false>(
  options?: Options<DeleteSlackIntegrationData, ThrowOnError>,
) =>
  (options?.client ?? client).delete<
    DeleteSlackIntegrationResponses,
    DeleteSlackIntegrationErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "X-Api-Key", type: "apiKey" },
    ],
    url: "/slack/integration",
    ...options,
  });

/**
 * Get the Slack integration for the current organization. Returns null if not connected.
 */
export const getSlackIntegration = <ThrowOnError extends boolean = false>(
  options?: Options<GetSlackIntegrationData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    GetSlackIntegrationResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "X-Api-Key", type: "apiKey" },
    ],
    url: "/slack/integration",
    ...options,
  });

/**
 * Update the Slack integration channel or enabled state.
 */
export const patchSlackIntegration = <ThrowOnError extends boolean = false>(
  options?: Options<PatchSlackIntegrationData, ThrowOnError>,
) =>
  (options?.client ?? client).patch<
    PatchSlackIntegrationResponses,
    PatchSlackIntegrationErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "X-Api-Key", type: "apiKey" },
    ],
    url: "/slack/integration",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });

/**
 * List Slack channels available to the bot. Results are cached for 5 minutes.
 */
export const getSlackChannels = <ThrowOnError extends boolean = false>(
  options?: Options<GetSlackChannelsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    GetSlackChannelsResponses,
    GetSlackChannelsErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "X-Api-Key", type: "apiKey" },
    ],
    url: "/slack/channels",
    ...options,
  });

/**
 * Send a test notification to the configured Slack channel.
 */
export const postSlackIntegrationTest = <ThrowOnError extends boolean = false>(
  options?: Options<PostSlackIntegrationTestData, ThrowOnError>,
) =>
  (options?.client ?? client).post<
    PostSlackIntegrationTestResponses,
    PostSlackIntegrationTestErrors,
    ThrowOnError
  >({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "X-Api-Key", type: "apiKey" },
    ],
    url: "/slack/integration/test",
    ...options,
  });

/**
 * List all active API tokens for the organization
 */
export const getApiTokens = <ThrowOnError extends boolean = false>(
  options?: Options<GetApiTokensData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetApiTokensResponses, unknown, ThrowOnError>(
    {
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api-tokens",
      ...options,
    },
  );

/**
 * Create a new API token for the organization. The token value is returned only once.
 */
export const postApiTokens = <ThrowOnError extends boolean = false>(
  options?: Options<PostApiTokensData, ThrowOnError>,
) =>
  (options?.client ?? client).post<
    PostApiTokensResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api-tokens",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });

/**
 * Revoke an API token
 */
export const deleteApiTokensById = <ThrowOnError extends boolean = false>(
  options: Options<DeleteApiTokensByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteApiTokensByIdResponses,
    DeleteApiTokensByIdErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api-tokens/{id}",
    ...options,
  });

/**
 * Upload a file
 *
 * Upload an image file (PNG, ICO, SVG, JPEG, GIF, WebP). Max 5MB.
 */
export const postUploads = <ThrowOnError extends boolean = false>(
  options?: Options<PostUploadsData, ThrowOnError>,
) =>
  (options?.client ?? client).post<
    PostUploadsResponses,
    PostUploadsErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    security: [{ scheme: "bearer", type: "http" }],
    url: "/uploads",
    ...options,
    headers: {
      "Content-Type": null,
      ...options?.headers,
    },
  });

/**
 * Update current user's default organization
 *
 * Set the authenticated user's stored default organization. The user must be a member of the target organization. Requires dashboard (JWT) authentication — API tokens are rejected.
 */
export const patchUsersMeDefaultOrganization = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<PatchUsersMeDefaultOrganizationData, ThrowOnError>,
) =>
  (options?.client ?? client).patch<
    PatchUsersMeDefaultOrganizationResponses,
    PatchUsersMeDefaultOrganizationErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/users/me/default-organization",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });

/**
 * List the probe zones this deployment operates in. Returned in the order configured via the ZONES_CONFIG env var; ids are what `monitors.regions` stores.
 */
export const getZones = <ThrowOnError extends boolean = false>(
  options?: Options<GetZonesData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetZonesResponses, unknown, ThrowOnError>({
    security: [
      { scheme: "bearer", type: "http" },
      { name: "X-Api-Key", type: "apiKey" },
    ],
    url: "/zones",
    ...options,
  });
